import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';

import { FilePicker } from './file-picker';
import { MaximumVideoFileSizeMB, allowedVideoFileExtensions } from '../utils/constants';

// to reuse existing test coverage, still keep class format
export class VideoFilePicker extends React.PureComponent {
  onFileReadInternal = (selectedFiles) => {
    const { onFileRead, enableMultiple } = this.props;

    return onFileRead(enableMultiple ? selectedFiles: _.first(selectedFiles));
  };


  getReachFileSizeLimitErrorMessage = () => {
    const { i18n } = this.props;

    return i18n.getString(
      'ImageExperience_Video_FileSize_Too_Big_Template',
      {
        maximumFileSize: MaximumVideoFileSizeMB / 1000,
      }
    );
  };

  showExtensionError = () => {
    const {
      i18n, showErrors, enableMultiple,
    } = this.props;

    const errorLinkText = i18n.getString('ImageExperience_BestPracticeHelp_Video');
    const errorTopic = 'app54794';

    showErrors([
      <span>
        {i18n.getString(`ImageExperience_${enableMultiple ? 'MultipleUpload_' : ''}Error_MediaFormatNotSupported`)}
        <LearnMoreLink
          linkText={errorLinkText}
          topic={errorTopic}
        />
      </span>,
    ]);
  };

  render() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { onFileRead, enableMultiple, ...rest } = this.props;

    return (
      <FilePicker
        allowedFileExtensions={allowedVideoFileExtensions}
        enableMultiple={enableMultiple}
        onFileRead={this.onFileReadInternal}
        isVideo
        maximumFileSize={MaximumVideoFileSizeMB}
        hideDescription
        getReachFileSizeLimitErrorMessage={this.getReachFileSizeLimitErrorMessage}
        showExtensionError={this.showExtensionError}
        {...rest}
      />
    );
  }
}

VideoFilePicker.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  enableMultiple: PropTypes.bool,
  onFileRead: PropTypes.func,
  showErrors: PropTypes.func.isRequired,
};

VideoFilePicker.defaultProps = {
  enableMultiple: false,
  onFileRead: _.noop,
};
